import { PropsWithChildren } from 'react';

import { generateLicenseConsumer } from '@frontend-libs/license-consumer';

import { usePortalPublicConfiguration } from '@frontend/portal-public-configuration';
import { useMetadata } from '@frontend/utils';

import { ActiveLicenses, defaultLicenses, scope } from './license.generated';

const {
  LicenseConsumer: GeneratedConsumer,
  useLicense,
  useLicenses,
} = generateLicenseConsumer<ActiveLicenses>({
  defaultLicenses,
  scope,
});

const LicenseConsumer = (props: PropsWithChildren) => {
  const { organizationId } = usePortalPublicConfiguration();
  const { appVersion, environment, stack, platform } = useMetadata();

  return (
    <GeneratedConsumer
      organizationId={organizationId}
      version={appVersion}
      environment={environment}
      stack={stack}
      platform={platform}
    >
      {props.children}
    </GeneratedConsumer>
  );
};

export { LicenseConsumer, useLicense, useLicenses };
